export default __webpack_public_path__ + "static/media/Logo_Javascript.1707d09a.png";